import $ from 'jquery';
import _ from 'underscore';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectDocuments',
			dom: {
				list: '#yotaConnectDocumentsList',
				template: '#yotaConnectDocumentsTemplate',
				print: '#yotaConnectDocumentsPrint',
				save: '#yotaConnectDocumentsSave',
				email: '#yotaConnectDocumentsEmail',
				form: '#yotaConnectDocumentsForm',
				input: '#yotaConnectDocumentsInput'
			},
			classes: {
				email: 'b-connect-documents_state_email'
			},
			data: {
				print: '#',
				save: '#',
				list: []
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.sended = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$list = this.$el.find(this.options.dom.list);
		this.$template = this.$el.find(this.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		this.$print = this.$el.find(this.options.dom.print);
		this.$save = this.$el.find(this.options.dom.save);
		this.$email = this.$el.find(this.options.dom.email);
		this.$form = this.$el.find(this.options.dom.form);
		this.$input = this.$el.find(this.options.dom.input);
		return this;
	}

	update(data) {
		const self = this;
		if (typeof data !== 'undefined') {
			self.data = data;
		}
		let html = '';
		$.each(self.data.list, function (key, item) {
			html += self.template(item);
		});
		self.$list.html(html);
		self.$print.attr('href', this.data.print);
		self.$save.attr('href', this.data.save);

		return self;
	}

	onEmail() {
		this.$el.addClass(this.options.classes.email);
	}

	onSubmit(event) {
		/* eslint no-alert: 0 */
		const self = this;
		event.preventDefault();
		if (!self.sended) {
			if (self.$input.val().trim() != '') {
				self.sended = true;
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success) {
							self.$input.val('');
							self.$el.removeClass(self.options.classes.email);
						}
						self.sended = false;
					},
					error: function () {
						self.sended = false;
					}
				});
			}
		}

		return self;
	}

	render() {
		if (this.$el.length) {
			this
				.getDom()
				.update();

			this.$email.on('click', this.onEmail.bind(this));
			this.$form.on('submit', this.onSubmit.bind(this));


		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/documents/documents.js